export class faqCMSModel {
    faq: any;
}


export class faqEntryIdObj {
  	entryIds = [
      { id:'VRrCFMz6AfyzYghmLBfks', text : 'faq'}
  	];
}